/* eslint-disable global-require,import/no-unresolved */
import React from 'react'
import PropTypes from 'prop-types'
import { ScrollView, Text, View } from 'react-native'

import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import styles, { colors } from '../../styles'
import textStyles from '../../styles/text'
import BlueChevronLinkText from '../subcomponents/BlueChevronLinkText'
import ConnectionOptions from '../subcomponents/ConnectionOptions'
import { trackEventAndNavigate } from '../../actions/helpers'

// eslint-disable-next-line react/prefer-stateless-function
class ChooseConnectionOption extends React.Component {
  render() {
    const {
      t, locale,
    } = this.props
    return (
      <View style={[styles.container, {
        flex: 1,
        flexDirection: 'column',
      }]}
      >
        <ScrollView
          contentContainerStyle={{ flexGrow: 1 }}
          style={{
            backgroundColor: colors.raven_grey20,
            flex: 1,
          }}
          testID="scrollview-ChooseConnectionOption"
        >
          <View style={[styles.container, styles.connectionsMainView]}>
            <View style={textStyles.h1Container}>
              <Text style={[textStyles.blueMediumText]} testID="communicator-connect-title">
                {t('howToConnectCommunicator')}
              </Text>
            </View>
            <ConnectionOptions
              t={t}
              locale={locale}
              testID="CCOPConnectionOptions"
            />
          </View>
          <View>
            <View style={[styles.learnMoreContainer]}>
              <Text style={styles.learnMoreHeader}>{t('common:learnMore')}</Text>
              <BlueChevronLinkText
                accessibilityLabel={t('access:whatsInBoxLink')}
                testID="whats-in-the-box"
                onPress={() => trackEventAndNavigate('WhatsInMonitorBoxPage', 'whatsInBox')}
              >
                {t('whatsInBox')}
              </BlueChevronLinkText>
              <BlueChevronLinkText
                accessibilityLabel={t('access:wherePlaceCommLink')}
                testID="place-communicator-btn"
                onPress={() => trackEventAndNavigate('WhereToPlaceMonitorPage', 'wherePlaceMonitor')}
              >
                {t('whereToPlaceCommunicator')}
              </BlueChevronLinkText>
              <BlueChevronLinkText
                accessibilityLabel={t('access:bestConnForMeLink')}
                testID="best-connection-btn"
                onPress={() => trackEventAndNavigate('BestConnectionPage', 'bestConnection')}
                last
              >
                {t('whichConnectionMethod')}
              </BlueChevronLinkText>
            </View>
          </View>
        </ScrollView>
      </View>
    )
  }
}

ChooseConnectionOption.propTypes = {
  locale: PropTypes.string,
  t: PropTypes.func.isRequired,
}

ChooseConnectionOption.defaultProps = {
  locale: 'en_US',
}

const mapStateToProps = (state) => {
  const { storedData } = state
  return {
    locale: storedData.locale,
  }
}

const actionCreators = {
}

export const ChooseConnectionOptionComponent = ChooseConnectionOption

export default withTranslation(['communicatorSetup', 'common'])(connect(mapStateToProps, actionCreators)(ChooseConnectionOption))
